module.exports = __webpack_public_path__ + "media/images/csv_sample_image-bbb8d3e8b67a94cfc8469abfc91bf851.png";